import L from 'leaflet';

export class FeatureCountControl extends L.Control {
  private containerElement!: HTMLElement;
  private count: number;

  constructor() {
    super();
    this.count = 0;
    this.containerElement = L.DomUtil.create(
      'div',
      'npdc-leaflet__cursor-position leaflet-bar',
    );
  }

  override onAdd() {
    return this.containerElement;
  }

  override onRemove() {
    this.containerElement.remove();
  }

  public get(): number {
    return this.count;
  }

  public set(value: number) {
    this.containerElement.innerText = value + '';
    this.count = value;
  }
}
